import tw from 'twin.macro';

export const FindPlaceImageContent = tw.div`w-full flex flex-col items-start justify-evenly px-[0.9rem] pt-[2.5rem] gap-4`;

export const FindPlaceImageClue = tw.div`w-full h-full flex items-center justify-between gap-4 mt-3`;
